import { useEffect } from "react";

/**
 * Per-route <title> and meta description.
 *
 * Uses the DOM directly rather than pulling in react-helmet — this is the
 * whole feature, and index.html already carries the static defaults that
 * crawlers see before JS runs.
 */
export const useDocumentTitle = (title, description) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      document
        .querySelector('meta[name="description"]')
        ?.setAttribute("content", description);
    }
  }, [title, description]);
};
